import { SelectItem } from 'primeng/api';
import { CustomerClusterService } from './../../../../services/customer/customer-cluster.service';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { CustomerSet } from './../../../../models/customer-set-model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-set-save',
  templateUrl: './customer-set-save.component.html',
  styleUrls: ['./customer-set-save.component.css']
})
export class CustomerSetSaveComponent implements OnInit {
  cronJobsStartDate: string;
  cronJobsEndDate: string;
  cronJobsForm: FormGroup;
  @Input() enabled = true;
  @Input() enabledDeleteCustomer = true;
  flgCreate = false;

  // Configurazione componente Cron-Jobs
  cronJobsConfig = {
    option: {
      minute: false,
      hour: true
    }
  };

  clusterHeadList: SelectItem[] = [];
  selectedClusterHead: number;

  @Input() setCode: string;
  @Input() setDescription: string;
  @Input() extSearchQuery: any;
  @Input() executionType: string;
  @Input() singleExecDate: any;
  @Input() recExecStartDate: any;
  @Input() recExecEndDate: any;
  @Input() cronJobsFrequency: string;
  @Input() clusterHeadId: number;
  @Input() planningDate: boolean;
  @Input() saveQuery: boolean;
  @Output() onCloseDialog: EventEmitter<any> = new EventEmitter();
  @Output() onSaveSet: EventEmitter<{code: string; description: string}> = new EventEmitter();

  giorno: string;
  ora: string;
  settimana: string;
  mese: string;
  anno: string;
  selezione: string;
  ogni: string;
  gen: string; feb: string;mar: string;apr: string;mag: string;giu: string;lug: string;ago: string;set: string;ott: string;nov: string;dic: string;
  constructor(
    public calendarTranslateService: CalendarTranslateService,
    private fb: FormBuilder,
    private customerClusterService: CustomerClusterService,
    private translateService: TranslateService,
  ) {

  }
  // Aggiungi una variabile per memorizzare il listener ed evitare memory leak
  private selectBaseChangeListener: () => void;
  ngAfterViewInit(): void {
    this.cambioLabel();
  }

  ngOnInit() {
    this.ora = this.translateService.instant('customerSetBuilder.hour');
    this.giorno = this.translateService.instant('customerSetBuilder.day');
    this.settimana = this.translateService.instant('customerSetBuilder.week');
    this.mese = this.translateService.instant('customerSetBuilder.month');
    this.anno = this.translateService.instant('customerSetBuilder.year');
    this.selezione = this.translateService.instant('customerSetBuilder.selection');
    this.ogni = this.translateService.instant('customerSetBuilder.every');
    this.gen = this.translateService.instant('customerSetBuilder.gen');
    this.feb = this.translateService.instant('customerSetBuilder.feb');
    this.mar = this.translateService.instant('customerSetBuilder.mar');
    this.apr = this.translateService.instant('customerSetBuilder.apr');
    this.mag = this.translateService.instant('customerSetBuilder.mag');
    this.giu = this.translateService.instant('customerSetBuilder.giu');
    this.lug = this.translateService.instant('customerSetBuilder.lug');
    this.ago = this.translateService.instant('customerSetBuilder.ago');
    this.set = this.translateService.instant('customerSetBuilder.set');
    this.ott = this.translateService.instant('customerSetBuilder.ott');
    this.nov = this.translateService.instant('customerSetBuilder.nov');
    this.dic = this.translateService.instant('customerSetBuilder.dic');
    this.cronJobsForm = this.fb.group({
      dateStart: [this.recExecStartDate || ''],
      dateEnd: [this.recExecEndDate || '']
    });
    this.customerClusterService.getClusterHeadAllList().subscribe(clusterHeads => {
      clusterHeads.forEach(ch => {
        this.clusterHeadList.push({
          label: `${ch.headDescription} - ${ch.clusterDescription}`,
          value: ch.clusterHeadId
        });
        if (this.clusterHeadId) {
          this.flgCreate = true;
          this.selectedClusterHead = this.clusterHeadId;
        }
      });
    });
  }

  setDefaultDateStart() {
    if (this.cronJobsForm.controls.dateStart.value) {
      return this.cronJobsForm.controls.dateStart.value;
    } else {
      return null;
    }
  }

  setDefaultDateEnd() {
    if (this.cronJobsForm.controls.dateEnd.value) {
      return this.cronJobsForm.controls.dateEnd.value;
    } else {
      return null;
    }
  }

  saveSet() {
    if (this.setCode && this.setDescription) {
      let startDate;
      if (this.executionType === 'single') {
        startDate = moment(new Date(this.singleExecDate)).format('YYYY-MM-DD');
        this.cronJobsFrequency = '';
      } else {
        startDate = moment(new Date(this.cronJobsForm.controls.dateStart.value)).format('YYYY-MM-DD');
      }
      const endDate = this.executionType === 'recurring' ? moment(new Date(this.cronJobsForm.controls.dateEnd.value)).format('YYYY-MM-DD') : null;
      const newSetData: CustomerSet = {
        code: this.setCode,
        description: this.setDescription,
        query_condition: this.extSearchQuery,
        flg_active: this.enabled ? '0' : '1',
        version: 1,
        query_count: 0,
        planned_start_date: startDate,
        planned_end_date: endDate,
        cron_string: this.cronJobsFrequency,
        cluster_head_id: this.flgCreate ? this.selectedClusterHead : null,
        flg_delete_customer: this.enabledDeleteCustomer ? '0' : '1',
      };
      this.onSaveSet.emit(newSetData);
    }
  }
  cambioLabel() {
    const self = this;
    setTimeout(() => {
      // Codice esistente per la prima select (selectBase)
      const selectElement = document.querySelector('#selectBase') as HTMLSelectElement;
      if (selectElement) {
        // Aggiorna le label iniziali
        this.updateSelectLabels(selectElement, self.selezione, self.ora, self.giorno, self.settimana, self.mese, self.anno);

        // Aggiungi listener per cambiamenti futuri
        if (this.selectBaseChangeListener) {
          selectElement.removeEventListener('change', this.selectBaseChangeListener);
        }
        this.selectBaseChangeListener = () => this.handleSelectBaseChange();
        selectElement.addEventListener('change', this.selectBaseChangeListener);
      }

      // Aggiorna la select "daysOfMonth" inizialmente
      this.updateDaysOfMonthLabels();

      // Aggiorna la select "Months" inizialmente
      this.updateMonthsLabels();

      // Codice esistente per la label
      const labelElement = document.querySelector('label[for="selectBase"]') as HTMLElement;
      if (labelElement) {
        labelElement.innerText = self.ogni;
      }
    }, 100);
  }

  private handleSelectBaseChange() {
    // Richiama l'aggiornamento delle label quando cambia selectBase
    if(this.translateService.currentLang === 'it')
      this.updateDaysOfMonthLabels();
    this.updateMonthsLabels();
  }
  private updateSelectLabels(
    selectElement: HTMLSelectElement,
    selectionText: string,
    hourText: string,
    dayText: string,
    weekText: string,
    monthText: string,
    yearText: string
  ) {
    const options = selectElement.options;
    options[0].text = selectionText;
    options[1].text = hourText;
    options[2].text = dayText;
    options[3].text = weekText;
    options[4].text = monthText;
    options[5].text = yearText;
  }

  private updateDaysOfMonthLabels() {
    const daysOfMonthSelect = document.querySelector('select[formcontrolname="daysOfMonth"]') as HTMLSelectElement;
    if (daysOfMonthSelect) {
      const options = daysOfMonthSelect.options;
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        const originalText = option.textContent;
        const numberMatch = originalText.match(/\d+/);
        if (numberMatch) {
          const number = numberMatch[0];
          // Esempio: Sostituisci "st", "nd", "rd", "th" con "°"
          option.textContent = number + '°'; // Personalizza secondo necessità
        }
      }
    }
  }

  private updateMonthsLabels() {
    const months = document.querySelector('select[formcontrolname="months"]') as HTMLSelectElement;
    if (months) {
      const options = months.options;

      options[0].text = this.gen;

      options[1].text = this.feb;

      options[2].text = this.mar;

      options[3].text = this.apr;

      options[4].text = this.mag;

      options[5].text = this.giu;

      options[6].text = this.lug;

      options[7].text = this.ago;

      options[8].text = this.set;

      options[9].text = this.ott;

      options[10].text = this.nov;

      options[11].text = this.dic;

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-save/customer-set-save.component.ts